var React =              require("react");
const {  Link  } = require('react-router-dom');

let IconsPreview =       require("../preview/IconsPreview.jsx");

class ImportConfirm extends IconsPreview {

    render() {
        let { id, name, type, newName, closeInconsisten, goOnVersion, switchSpinning } = this.props;
                
        if(type === "overwrite"){
            return  <div className="contInconsistent">
                        <div className="contInconsistent__iconWarning">{this.getIconWarning()}</div>
                        <h2>Inconsistent Filename</h2>
                        <p>The library you selected does not match the name of your library.</p>
                        <p>Are you sure you want to replace your library with <span className="name">{newName}</span>?</p>
                        <div className="contButtons">
                            <button className="button transparent" onClick={closeInconsisten}>Cancel</button>
                            <button className="button transparent" onClick={() => goOnVersion(id, name)}>Continue</button>
                        </div>
                    </div>
        }else{
            return  <div className="contInconsistent">
                        <div className="contInconsistent__iconSuccess">{this.getIconSuccess()}</div>
                        <h2>New version successfully created!</h2>
                        <div className="contButtons">
                            <Link to={{ pathname: `/libraries/${id}-${name}`, state: { modal: true, newVersion: true }}}>
                                <button className="button transparent" onClick={() => switchSpinning({show: false})}>View</button>
                            </Link>
                        </div>
                    </div>
        }
    }
}

module.exports = ImportConfirm;
